import { Injectable } from '@angular/core';
// import * as jwt_decode from "jwt-decode";
import jwt_decode from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export default class BaseTokenService {

  //authTokenProp: any;

  constructor(private cookieService: CookieService) { }

  isValidToken(authToken?: any): boolean {

    let retVal = false;

    //using cookie service will only work on local
    let tokenFromBackend;

    if (authToken) {

      tokenFromBackend = authToken;  //this.cookieService.get('authTokenFromBackend');

    } else {


      // if(this.authTokenProp && this.authTokenProp != '') {

      //   tokenFromBackend = this.authTokenProp;

      // } else {

      tokenFromBackend = this.cookieService.get('authTokenFromBackend');

      //}

    }

    if (tokenFromBackend && tokenFromBackend != '') {

      let decodedToken = this.getDecodedAccessToken(tokenFromBackend);

      var expirationDateAndTime = new Date(decodedToken.Expiration);
      var currentDateAndTime = new Date(Date.now());

      var isExpired = false;

      if (currentDateAndTime > expirationDateAndTime) {

        isExpired = true;
        retVal = false;

      } else {

        retVal = true;

      }

    }

    return retVal;
  }

  //https://stackoverflow.com/questions/48075688/how-to-decode-the-jwt-encoded-token-payload-on-client-side-in-angular
  getDecodedAccessToken(token: string): any {

    try {

      return jwt_decode(token);

    } catch (Error) {

      return null;

    }

  }

  getUserRole(): any {

    let role: string = '';

    let tokenFromBackend = this.cookieService.get('authTokenFromBackend');

    if (tokenFromBackend != '') {

      let decodedAccessToken: any = this.getDecodedAccessToken(tokenFromBackend);

      role = decodedAccessToken.Role;
    }

    return role;
  }

  getUserName(): any {
    
    let tokenFromBackend = this.cookieService.get('authTokenFromBackend');

    let decodedAccessToken: any = this.getDecodedAccessToken(tokenFromBackend);

    let role: any = decodedAccessToken.Name;

    return role;

  }

}
